import React, { useEffect, useState } from "react"
import { Avatar, Box, Typography } from "@mui/material"
import { avatarUrlDecorator } from "@app/data/avatarUrl"
import ParticipantsListDialog from "@components/Dialogs/ParticipantsListDialog"
import { isNonEmptyArray } from "@utils/array.utils"

type UsersWhoParticipantsOfEventDto = {
  participant_id: number
  participant_avatar_url?: string
  participant_username?: string
  participant_name?: string
}

type GroupCardProps = {
  participants?: UsersWhoParticipantsOfEventDto[]
}

const GroupCard: React.FC<GroupCardProps> = ({ participants }) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false)
  const clickHandler = () => {
    if (isNonEmptyArray(participants) && !openDialog) {
      setOpenDialog(true)
    }
  }

  const handleCloseDialog = () => {
    setOpenDialog(() => false)
  }
  useEffect(() => {}, [openDialog])

  const nounDeclension = (n: number, texts: string[]) =>
    texts[
      (n %= 100) > 10 && n < 20
        ? 2
        : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
    ]

  return (
    <Box
      onClick={clickHandler}
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "var(--surface-bg)",
        borderRadius: "16px",
        padding: "8px 16px",
        maxWidth: "364px",
        "&:hover": {
          cursor: "pointer",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          marginRight: "12px",
        }}
      >
        {participants?.slice(0, 4).map((participant, index) => (
          <Avatar
            key={participant.participant_id}
            src={avatarUrlDecorator(participant.participant_avatar_url)}
            sx={{
              width: 40,
              height: 40,
              marginLeft: index !== 0 ? "-12px" : 0,
              border: "2px solid var(--borders)",
            }}
          />
        ))}
      </Box>
      <Typography sx={{ color: "#B0B0B0", fontWeight: 600 }}>
        +{participants?.length}
        {nounDeclension(participants?.length || 0, [
          " участник",
          " участника",
          " участников",
        ])}
      </Typography>
      <Typography
        sx={{
          marginLeft: "auto",
          color: "var(--Schemes-Primary)",
          fontWeight: 600,
        }}
      >
        Все
      </Typography>
      {isNonEmptyArray(participants) && (
        <ParticipantsListDialog
          participants={participants}
          open={openDialog}
          onClose={handleCloseDialog}
        />
      )}
    </Box>
  )
}

export default GroupCard
